import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import MeetingMain from 'flow/components/meeting/shared/MeetingMain';
import Page from 'flow/components/Setting/Page';
import { jsx as _jsx } from "react/jsx-runtime";
var Conference = /*#__PURE__*/function (_React$PureComponent) {
  function Conference() {
    _classCallCheck(this, Conference);
    return _callSuper(this, Conference, arguments);
  }
  _inherits(Conference, _React$PureComponent);
  return _createClass(Conference, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx(Page, {
        header: "",
        children: /*#__PURE__*/_jsx(MeetingMain, {})
      });
    }
  }]);
}(React.PureComponent);
export default Conference;